import type { OrderComment } from '@/infrastructure/FulfillmentAdminClient';
import { logTimestamp } from '../activityLog';
import { withMentions } from '@/pages/fulfillment/components/mentionText';

/** The same full, read-only memo on the order row and at the scanner. */
export function LineMemoThread({ comments }: { comments: readonly OrderComment[] }) {
  return (
    <>
      {comments.map((memo, index) => (
        <div className="note-line" key={`${memo.at}-${memo.author}-${index}`}>
          <b>{memo.author}</b>
          <span className="note-text">{withMentions(memo.text)}</span>
          <time dateTime={memo.at}>{logTimestamp(memo.at)}</time>
        </div>
      ))}
    </>
  );
}
